/** @jsxImportSource @emotion/react */
import { EuiButtonIcon, EuiPageTemplate } from "@inscopix/ideas-eui";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import { Helmet } from "react-helmet-async";
import { PanelTenantAccess } from "components/PanelTenantAccess/PanelTenantAccess";
import { useState } from "react";
import { ModalEditOrganization } from "components/ModalEditOrganization/ModalEditOrganization";
import { useUserContext } from "providers/UserProvider/UserProvider";
import { TENANT_MEMBERSHIP_ROLES_BY_KEY } from "types/TenantMembershipRole";
import { Tooltip } from "components/Tooltip/Tooltip";
import {
  useSetCurrentPage,
  useSetTourCondition,
} from "providers/TourProvider/TourProvider.hooks";
import { css } from "@emotion/react";

export const OrganizationPeople = () => {
  const currentUser = useUserContext((s) => s.currentUser);
  const currentTenant = useTenantContext((s) => s.currentTenant);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const currentUserRole = useTenantContext((s) => {
    const defaultRole = TENANT_MEMBERSHIP_ROLES_BY_KEY["member"];
    const user = s.usersById.get(currentUser.id);
    return user?.role ?? defaultRole;
  });
  useSetCurrentPage("organizationPeople");
  useSetTourCondition("isOrgAdmin", currentUserRole.key === "admin");

  return (
    <>
      {isModalVisible && (
        <ModalEditOrganization onClose={() => setIsModalVisible(false)} />
      )}
      <Helmet>
        <title>{currentTenant.name}: People</title>
      </Helmet>
      <EuiPageTemplate
        restrictWidth={false}
        css={css`
          max-width: 1000px;
          margin: auto;
          width: max(600px, 75vw);
        `}
      >
        <EuiPageTemplate.Header
          alignItems="center"
          pageTitle={currentTenant.name}
          responsive={false}
          rightSideItems={[
            currentUserRole.key === "admin" && (
              <Tooltip content={"Edit organization name"}>
                <EuiButtonIcon
                  key="edit"
                  aria-label="Edit organization name"
                  iconType="pencil"
                  onClick={() => setIsModalVisible(true)}
                />
              </Tooltip>
            ),
          ]}
        />
        <EuiPageTemplate.Section color={"transparent"}>
          <PanelTenantAccess />
        </EuiPageTemplate.Section>
      </EuiPageTemplate>
    </>
  );
};
